var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile is-parent is-7" }, [
      _c("article", { staticClass: "tile is-child box" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Detail Info")]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Type")]),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.entity.isPerson,
                  expression: "entity.isPerson",
                },
              ],
              staticClass: "is-checkradio",
              attrs: { id: "company", type: "radio", name: "company" },
              domProps: {
                value: false,
                checked: _vm._q(_vm.entity.isPerson, false),
              },
              on: {
                click: function ($event) {
                  return _vm.setIsPerson(false)
                },
                change: function ($event) {
                  return _vm.$set(_vm.entity, "isPerson", false)
                },
              },
            }),
            _c("label", { attrs: { for: "company" } }, [_vm._v("Company")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.entity.isPerson,
                  expression: "entity.isPerson",
                },
              ],
              staticClass: "is-checkradio",
              attrs: { id: "person", type: "radio", name: "person" },
              domProps: {
                value: true,
                checked: _vm._q(_vm.entity.isPerson, true),
              },
              on: {
                click: function ($event) {
                  return _vm.setIsPerson(true)
                },
                change: function ($event) {
                  return _vm.$set(_vm.entity, "isPerson", true)
                },
              },
            }),
            _c("label", { attrs: { for: "person" } }, [_vm._v("Person")]),
          ]),
        ]),
        _c("div", { staticClass: "is-divider" }),
        _vm.entity.isPerson
          ? _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Title")]),
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.entity.title,
                          expression: "entity.title",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.entity,
                            "title",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    _vm._l(_vm.titles, function (a, b) {
                      return _c("option", { key: a, domProps: { value: a } }, [
                        _vm._v(_vm._s(b)),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "field" }, [
          _vm.entity.isPerson
            ? _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("First Name"),
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.entity.firstname,
                          expression: "entity.firstname",
                        },
                        {
                          name: "focus-inserted",
                          rawName: "v-focus-inserted",
                          value: { focus: _vm.entity.isPerson },
                          expression: "{ focus: entity.isPerson }",
                        },
                      ],
                      staticClass: "input is-capitalized",
                      class: {
                        "is-danger": _vm.$v.entity.firstname.$error,
                        "is-warning": _vm.nameExists,
                      },
                      attrs: {
                        id: "fName",
                        type: "text",
                        placeholder: "First Name",
                        maxlength: "40",
                      },
                      domProps: { value: _vm.entity.firstname },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.entity,
                              "firstname",
                              $event.target.value
                            )
                          },
                          function ($event) {
                            _vm.$v.entity.firstname.$touch()
                            _vm.checkNameExists()
                          },
                        ],
                      },
                    }),
                    _vm.$v.entity && !_vm.$v.entity.firstname.required
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("Firstname is required. "),
                        ])
                      : _vm._e(),
                    _vm.nameExists
                      ? _c("span", { staticClass: "help is-warning" }, [
                          _vm._v("Name already exists. "),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _c("div", { staticClass: "column" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Last Name")]),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.entity.lastname,
                          expression: "entity.lastname",
                        },
                      ],
                      staticClass: "input is-capitalized",
                      class: {
                        "is-danger": _vm.$v.entity.lastname.$error,
                        "is-warning": _vm.nameExists,
                      },
                      attrs: {
                        id: "lName",
                        type: "text",
                        placeholder: "Last Name",
                        maxlength: "40",
                      },
                      domProps: { value: _vm.entity.lastname },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.entity,
                              "lastname",
                              $event.target.value
                            )
                          },
                          function ($event) {
                            _vm.$v.entity.lastname.$touch()
                            _vm.checkNameExists()
                          },
                        ],
                      },
                    }),
                    _vm.$v.entity && !_vm.$v.entity.lastname.required
                      ? _c("span", { staticClass: "help is-danger" }, [
                          _vm._v("Lastname is required. "),
                        ])
                      : _vm._e(),
                    _vm.nameExists
                      ? _c("span", { staticClass: "help is-warning" }, [
                          _vm._v("Name already exists. "),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ])
            : _vm._e(),
          !_vm.entity.isPerson
            ? _c("label", { staticClass: "label" }, [_vm._v("Company Name")])
            : _vm._e(),
          !_vm.entity.isPerson
            ? _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.entity.companyName,
                      expression: "entity.companyName",
                    },
                    {
                      name: "focus-inserted",
                      rawName: "v-focus-inserted",
                      value: { focus: !_vm.entity.isPerson },
                      expression: "{ focus: !entity.isPerson }",
                    },
                  ],
                  staticClass: "input is-capitalized",
                  class: {
                    "is-danger": _vm.$v.entity.companyName.$error,
                    "is-warning": _vm.companyNameExists,
                  },
                  attrs: {
                    id: "cName",
                    type: "text",
                    placeholder: "Company Name",
                    maxlength: "120",
                  },
                  domProps: { value: _vm.entity.companyName },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.entity, "companyName", $event.target.value)
                      },
                      function ($event) {
                        _vm.$v.entity.companyName.$touch()
                        _vm.checkNameExists()
                      },
                    ],
                  },
                }),
                _vm.$v.entity && !_vm.$v.entity.companyName.required
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v("Company name is required. "),
                    ])
                  : _vm._e(),
                _vm.companyNameExists
                  ? _c("span", { staticClass: "help is-warning" }, [
                      _vm._v("Company name already exists. "),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "field-body" }, [
            _c("div", { staticClass: "field is-narrow" }, [
              _c("label", { staticClass: "label" }, [_vm._v("ABN")]),
              _c(
                "div",
                { staticClass: "control has-icons-right" },
                [
                  _vm.$company.info.countryCode === "AU"
                    ? _c("the-mask", {
                        staticClass: "input",
                        class: { "is-danger": _vm.$v.entity.abn.$error },
                        attrs: {
                          id: "abn",
                          name: "abn",
                          placeholder: "ABN",
                          mask: ["## ### ### ###"],
                        },
                        nativeOn: {
                          input: function ($event) {
                            return _vm.$v.entity.abn.$touch()
                          },
                        },
                        model: {
                          value: _vm.entity.abn,
                          callback: function ($$v) {
                            _vm.$set(_vm.entity, "abn", $$v)
                          },
                          expression: "entity.abn",
                        },
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.entity.abn,
                            expression: "entity.abn",
                          },
                        ],
                        ref: "abn",
                        staticClass: "input is-uppercase",
                        attrs: { id: "abn", maxlength: "12" },
                        domProps: { value: _vm.entity.abn },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(_vm.entity, "abn", $event.target.value)
                            },
                            function ($event) {
                              return _vm.$v.entity.abn.$touch()
                            },
                          ],
                        },
                      }),
                  !_vm.$v.entity.abn.$error &&
                  _vm.entity.abn &&
                  _vm.$company.info.countryCode === "AU"
                    ? _c(
                        "span",
                        { staticClass: "icon has-text-success is-right" },
                        [_c("i", { staticClass: "mdi mdi-check mdi-18px" })]
                      )
                    : _vm._e(),
                  _vm.$v.entity && !_vm.$v.entity.abn.minLength
                    ? _c("span", { staticClass: "help is-danger" }, [
                        _vm._v(
                          "ABN must be at least " +
                            _vm._s(_vm.$v.entity.abn.$params.minLength.min) +
                            " letters."
                        ),
                      ])
                    : _vm.$v.entity && !_vm.$v.entity.abn.validAbn
                    ? _c("span", { staticClass: "help is-danger" }, [
                        _vm._v("ABN format is invalid."),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-narrow" }, [
              _c("label", { staticClass: "label" }, [_vm._v("BSB")]),
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field is-narrow" }, [
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("the-mask", {
                        staticClass: "input",
                        class: { "is-danger": _vm.$v.entity.bsb.$error },
                        attrs: {
                          type: "text",
                          placeholder: "BSB",
                          mask: ["###-###"],
                        },
                        nativeOn: {
                          input: function ($event) {
                            return _vm.$v.entity.bsb.$touch()
                          },
                        },
                        model: {
                          value: _vm.entity.bsb,
                          callback: function ($$v) {
                            _vm.$set(_vm.entity, "bsb", $$v)
                          },
                          expression: "entity.bsb",
                        },
                      }),
                      _vm.$v.entity && !_vm.$v.entity.bsb.minLength
                        ? _c("span", { staticClass: "help is-danger" }, [
                            _vm._v(
                              "BSB must be at least " +
                                _vm._s(
                                  _vm.$v.entity.bsb.$params.minLength.min
                                ) +
                                " letters."
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "column" }, [
              _c("label", { staticClass: "label" }, [_vm._v("Account No")]),
              _c(
                "div",
                { staticClass: "control" },
                [
                  _c("the-mask", {
                    staticClass: "input",
                    attrs: {
                      type: "text",
                      placeholder: "Account No.",
                      mask: ["##########"],
                    },
                    model: {
                      value: _vm.entity.accountNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.entity, "accountNo", $$v)
                      },
                      expression: "entity.accountNo",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("G/L Account")]),
          _c(
            "div",
            { staticClass: "control" },
            [
              _vm.glAccountListCombo
                ? _c(
                    "multiselect",
                    {
                      attrs: {
                        options: _vm.glAccountListCombo,
                        placeholder: "Select account",
                        label: "displayName",
                        "track-by": "accountNo",
                        "allow-empty": false,
                      },
                      model: {
                        value: _vm.selectedGlAccountObject,
                        callback: function ($$v) {
                          _vm.selectedGlAccountObject = $$v
                        },
                        expression: "selectedGlAccountObject",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "has-text-danger",
                          attrs: { slot: "noResult" },
                          slot: "noResult",
                        },
                        [_vm._v("G/L account not found.")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.$v.entity && !_vm.$v.entity.customerGLCode.required
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v("G/L Account is required. "),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "pretty p-icon p-curve p-smooth p-bigger" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.entity.exported,
                expression: "entity.exported",
              },
            ],
            attrs: { type: "checkbox", disabled: !_vm.$userInfo.isSupportUser },
            domProps: {
              checked: Array.isArray(_vm.entity.exported)
                ? _vm._i(_vm.entity.exported, null) > -1
                : _vm.entity.exported,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.entity.exported,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.entity, "exported", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.entity,
                        "exported",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.entity, "exported", $$c)
                }
              },
            },
          }),
          _vm._m(0),
        ]),
        _c("div", { staticClass: "is-divider" }),
        _vm.$user.hasDelete(_vm.$route.meta.id)
          ? _c("div", { staticClass: "buttons has-addons is-centered" }, [
              _c(
                "span",
                {
                  staticClass: "button",
                  class: { "is-success is-selected": _vm.entity.active },
                  on: {
                    click: function ($event) {
                      return _vm.toggleActive(true)
                    },
                  },
                },
                [_vm._m(1), _c("span", [_vm._v("Active")])]
              ),
              _c(
                "span",
                {
                  staticClass: "button",
                  class: { "is-danger is-selected": !_vm.entity.active },
                  on: {
                    click: function ($event) {
                      return _vm.toggleActive(false)
                    },
                  },
                },
                [_vm._m(2), _c("span", [_vm._v("In-Active")])]
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _c("div", { staticClass: "tile is-parent" }, [
      _c("article", { staticClass: "tile is-child box" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Vehicles")]),
        _c(
          "table",
          {
            staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
          },
          [
            _vm._m(3),
            _vm.vehicles && _vm.vehicles.length > 0
              ? _c(
                  "tbody",
                  _vm._l(_vm.vehicles, function (vehicle) {
                    return _c("tr", { key: vehicle.vehicleId }, [
                      _c("td", [_vm._v(" " + _vm._s(vehicle.rego) + " ")]),
                      _c("td", [_vm._v(_vm._s(vehicle.makeModel))]),
                    ])
                  }),
                  0
                )
              : _c("tbody", [_vm._m(4)]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Exported")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-close" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", [_vm._v("Rego")]),
      _c("th", [_vm._v("Make & Model")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { staticClass: "has-text-centered", attrs: { colspan: "2" } }, [
        _c("span", { attrs: { icon: "icon is-medium" } }, [
          _c("i", {
            staticClass:
              "mdi mdi-36px mdi-dots-horizontal mdi-inactive-color mdi-inactive",
          }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }